<template>
  <TenantNavbar />
  <!-- <v-system-bar>System Bar</v-system-bar> -->
  <slot />
</template>

<script setup lang="ts">
import TenantNavbar from '@/layouts/navigation/TenantNavbar.vue'
</script>
